export default () => {
  $('button.nav-toggle').on('click', function() {
    $(this)
      .parent()
      .toggleClass('is-active');
  });
  $('.C2B_Button_Blue').on('click', function() {
    $(document.body).addClass('stop-scrolling');
  });
  $('.close, .C2BC_close').on('click', function() {
    $(document.body).removeClass('stop-scrolling');
  });
};
